import React from 'react';
import { useExpandableText } from './hooks';
import {
  ExpandedText,
  ExpandText,
  InitialText,
  LastLine,
  LastLineContainer,
  LastLineWrapper,
  SingleLine,
  Wrapper,
} from './styles';
import { ExpandableTextProps } from './types';

export const ExpandableText: React.FC<ExpandableTextProps> = (props) => {
  const {
    collapsedHeight,
    collapseText,
    expandedHeight,
    expandedRef,
    expandTextRef,
    expandTextWidth,
    expandText,
    numberOfLines,
    handleExpand,
    handleCollapse,
    isExpanded,
    lineHeight,
    showExpand,
    singleLineRef,
    text,
  } = useExpandableText(props);

  return (
    <div>
      <Wrapper>
        <InitialText style={{ height: isExpanded || !showExpand ? expandedHeight : collapsedHeight }}>
          {text}
          {showExpand && collapseText && isExpanded && (
            <ExpandText data-role={'collapse-text'} isExpanded onClick={handleCollapse}>
              {collapseText}
            </ExpandText>
          )}
        </InitialText>
        {!isExpanded && showExpand && (
          <LastLineContainer>
            <LastLineWrapper style={{ height: lineHeight }} expandTextWidth={expandTextWidth}>
              <LastLine
                numberOfLines={numberOfLines}
                style={{
                  transform: `translateY(-${lineHeight * (numberOfLines - 1)}px)`,
                }}>
                {text}
              </LastLine>
            </LastLineWrapper>
            {expandText && !isExpanded && (
              <ExpandText data-role={'expand-text'} ref={expandTextRef} onClick={handleExpand}>
                {expandText}
              </ExpandText>
            )}
          </LastLineContainer>
        )}
        <ExpandedText ref={expandedRef}>{text}</ExpandedText>
        <SingleLine ref={singleLineRef}>{text}</SingleLine>
      </Wrapper>
    </div>
  );
};
